<button class="debugButton" (click)="toggleAbility()">Toggle</button>

<div class="wrap" *ngIf="ability == 'super-admin'">
    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li (click)="goToVirement()">
                <a href="/facturation/virements">
                    Encaissement
                </a>
            </li>
            <li class="uk-active">
                <a>
                    Controle
                </a>
            </li>
            <li (click)="goToGain()">
                <a href="/facturation/gain">
                    Auto Facturation
                </a>
            </li>
        </ul>
    </div>

    <div class="uk-child-width-expand@s uk-text-center" uk-grid>
        <div>
            <div [class.uk-text-danger]="totalEncaisser < totalVerser"
                [class.uk-text-success]="totalEncaisser > totalVerser"
                class="uk-card uk-border-rounded uk-card-default uk-card-body">
                <div class="uk-text-large bold">
                    Somme Encaissée
                </div>
                <div class="uk-text-bold">
                    {{ this.totalEncaisser }} €
                </div>
            </div>
        </div>
        <div>
            <div [class.uk-text-danger]="totalEncaisser < totalVerser"
                [class.uk-text-success]="totalEncaisser > totalVerser"
                class="uk-card uk-border-rounded uk-card-default uk-card-body">
                <div class="uk-text-large bold">
                    Somme Verser
                </div>
                <div class="uk-text-bold">
                    {{ this.totalVerser }} €
                </div>
            </div>
        </div>
        <div>
            <div [class.uk-text-danger]="totalEncaisser < totalVerser"
                [class.uk-text-success]="totalEncaisser > totalVerser"
                class="uk-card uk-border-rounded uk-card-default uk-card-body">
                <div class="uk-text-large bold">
                    Gain
                </div>
                <div class="uk-text-bold">
                    {{ this.totalGain }} €
                </div>
            </div>
        </div>
    </div>

    <div
        class="uk-border-rounded uk-text-center uk-width-1-1 vop-background-white uk-margin-medium-top uk-padding-small">
        <div uk-grid class="uk-width-3-3 reservation-list remove-grid-ml-pl">
            <div class="uk-width-1-5 item-column bold" style="font-size: 17px;">
                <div class="uk-display-block">
                    Adherent
                </div>
                <div class="separator"></div>
            </div>
            <div class="uk-visible uk-width-expand item-column"></div>
            <div class="uk-visible uk-text-center uk-width-1-4 bold item-column" style="font-size: 17px;">
                Versement
            </div>
            <div class="uk-visible uk-text-center uk-width-1-4 bold item-column" style="font-size: 17px;">
                Encaissement
            </div>
            <div class="uk-visible uk-text-center uk-width-1-4 bold item-column" style="font-size: 17px;">
                Gain
            </div>
        </div>

        <div uk-grid *ngFor="let controle of controles; let i = index"
            class="uk-width-3-3 reservation-list remove-grid-ml-pl pointer"
            [routerLink]="['/user/society/informations/', controle.id]"
            [class.uk-text-danger]="controle.encaisser < controle.verser"
            [class.uk-text-success]="controle.encaisser > controle.verser">
            <div class="uk-width-1-5 item-column bold" style="font-size: 17px;">
                <div class="uk-display-block">
                    {{controle.adherent}}
                </div>
                <div class="separator"></div>
            </div>
            <div class="uk-visible uk-width-expand item-column"></div>
            <div class="uk-visible uk-text-center uk-width-1-4 item-column" style="font-size: 15px;">
                {{ controle.verser }} €
            </div>

            <div class="uk-visible uk-text-center uk-width-1-4 item-column" style="font-size: 15px;">
                {{ controle.encaisser }} €
            </div>

            <div class="uk-visible uk-text-center uk-width-1-4 item-column" style="font-size: 15px;">
                {{ controle.gain }} €
            </div>
        </div>
    </div>
</div>

<!-- partie admin -->
<div class="wrap" *ngIf="ability == 'admin'">
    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li (click)="goToVirement()">
                <a href="/facturation/virements">
                    Encaissement
                </a>
            </li>
            <li class="uk-active">
                <a>
                    Controle
                </a>
            </li>
            <li (click)="goToGain()">
                <a href="/facturation/gain">
                    Auto Facturation
                </a>
            </li>
        </ul>
    </div>

    <div class="uk-child-width-expand@s uk-text-center" uk-grid>
        <div>
            <div [class.uk-text-danger]="totalEncaisser < totalVerser"
                [class.uk-text-success]="totalEncaisser > totalVerser"
                class="uk-card uk-border-rounded uk-card-default uk-card-body">
                <div class="uk-text-large bold">
                    Somme Encaissée
                </div>
                <div class="uk-text-bold">
                    {{ this.totalEncaisser }} €
                </div>
            </div>
        </div>
        <div>
            <div [class.uk-text-danger]="totalEncaisser < totalVerser"
                [class.uk-text-success]="totalEncaisser > totalVerser"
                class="uk-card uk-border-rounded uk-card-default uk-card-body">
                <div class="uk-text-large bold">
                    Somme Verser
                </div>
                <div class="uk-text-bold">
                    {{ this.totalVerser }} €
                </div>
            </div>
        </div>
    </div>

    <div
        class="uk-border-rounded uk-text-center uk-width-2-2 vop-background-white uk-margin-medium-top uk-padding-small">
        Graphique Statistique...
    </div>
</div>